<div class="flex items-center justify-center min-h-screen bg-gray-100">
  <div class="bg-white shadow p-8 rounded max-w-md w-full text-center">
    <h2 class="text-2xl font-bold mb-4 dark:text-black">Create Test</h2>

    <!-- Initial form -->
    <ng-container *ngIf="!isRunning() && !isComplete()">
      <div class="mb-4">
        <input
          type="text"
          placeholder="Enter domain"
          name="domain"
          class="border rounded w-full px-3 py-2"
          [(ngModel)]="domain"
        />
        <select
          name="filter"
          class="border rounded w-full px-3 py-2 mt-4"
          [(ngModel)]="filter"
        >
          <option value="test-run" selected>Test Run</option>
          <option value="performance">Performance</option>
          <option value="accessibility">Accessibility</option>
          <option value="wordpress">Wordpress</option>
        </select>

      </div>
      <button
        (click)="onSubmit()"
        class="bg-apricot-800 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        Submit
      </button>
    </ng-container>

    <!-- Running test -->
    <ng-container *ngIf="isRunning()">
      <p class="mb-4 dark:text-black">Running test for {{ domain }}...</p>
      <div class="dark:text-black">
        {{ testProgress() }}
      </div>
    </ng-container>

    <!-- Completed test -->
    <ng-container *ngIf="isComplete()">
      <p class="mb-4 dark:text-black">Test Completed!</p>
    </ng-container>
  </div>
</div>
